export const createNotificationObj = (text = '', state = '', persistence = false, persistOnPageChange = false, button = {}) => ({
    text,
    state,
    persistence,
    persistOnPageChange,
    button
});
